export const Contact = () => {
  return (
    <div>
      <p>
        Thank you for your interest in our animal rescue organization. We are dedicated to helping animals in need and
        appreciate your support. If you have any questions or comments, please don't hesitate to reach out to us.

      </p>
      <p>
        Email:<a href="mailto: brooklynanimalrescuers@gmail.com ">brooklynanimalrescuers@gmail.com</a>
      </p>
      <p>
        We are also active on social media and can be reached through our Facebook and
        Instagram pages. Thank you for supporting animal rescue efforts. Together, we can make a difference for animals
        in need.
      </p>
    </div>
  );
};
